export const ROUTERS = {
  SIGN_IN: "/sign-in",
  HOME: "/",
  DASHBOARD: "/dashboard",
  MY_CLASS: "/my-class",
  MY_CLASS_DETAIL: "/my-class/detail/$id",
  USER_MANAGEMENT: "/user-management",
  CREATE_MOCK_TEST: "/create-mock-test",
  CREACT_PRACTICE_TEST: "create-practice-test/$classId/$ptId?",
  MOCK_TEST: "/mock-test",
  MOCK_TEST_RESULT: "/mock-test/result/$id",
  ERROR: "/error",
} as const;

export const ROUTER_HELPERS = {
  myClassDetail: (id: number) => `${ROUTERS.MY_CLASS}/detail/${id}`,
  mockTestResult: (id: number) => `${ROUTERS.MOCK_TEST}/result/${id}`,
  CreactPracticeTest: (classId: number, ptId?: number) =>
    `/create-practice-test/${classId}/${ptId || 0}`,
  error: (status: number) => `${ROUTERS.ERROR}/${status}`,
};

export const ROUTER_KEYS = {
  HOME: "HOME",
  DASHBOARD: "DASHBOARD",
  MOCK_TEST: "MOCK_TEST",
  MOCK_TEST_RESULT: "MOCK_TEST_RESULT",
};
